import { apiWrapper } from "@/services/api";
import store from "@/store/index";

export const createBookGroup = async (params) => {
  let response;
  try {
    response = await apiWrapper("POST", "book_groups", params);
    store.commit("ticketing/setbookGroup", response.data);
    store.commit("ticketing/setBook", response.data.books[0]);
    return response.data;
  } catch (err) {
    console.log('ERROR"" createBookGroup():', err);
    throw err;
  }
};
